import { useEffect } from "react";

//@ts-expect-error
import { useInView } from "react-intersection-observer";

import { useAnalyticsEvents } from "@atlaskit/analytics-next";

import { JPDOverlayTemplate } from "@/components/signup/layouts/product-overlay-template.tsx";
import {
    UfoCustomTimingKey,
    UfoCustomTimingWrapper,
    ufoEventRedirectToProduct
} from "@/components/signup/utils";

import { useCloudStatus, useCloudStatusRedirection } from "../../hooks";

import { LoadingAnimationContainer } from "./loading-animation-container";

export const JiraProductDiscoveryProvisioningUi = () => {
    const { ref } = useInView();
    const { createAnalyticsEvent } = useAnalyticsEvents();
    const { triggerOnSuccess, startPerceivedProvisioningTimer } =
        useCloudStatus();
    const { redirectUrl } = useCloudStatusRedirection();

    useEffect(() => {
        startPerceivedProvisioningTimer();
    }, [startPerceivedProvisioningTimer]);

    useEffect(() => {
        if (redirectUrl) {
            ufoEventRedirectToProduct.success({
                customData: {
                    reactComponent: "JPD default",
                    analyticsEvent: "redirected",
                    redirectFrom: "confirmationPage",
                    provisioningStatus: "success"
                }
            });
            window.location.assign(redirectUrl);
        }
    }, [createAnalyticsEvent, triggerOnSuccess, redirectUrl]);

    return (
        <div ref={ref} data-testid="jpd-provisioning-ui">
            <UfoCustomTimingWrapper
                ufoEvent={ufoEventRedirectToProduct}
                ufoCustomTimingKey={
                    UfoCustomTimingKey.JIRA_PRODUCT_DISCOVERY_ONBOARDING_SPINNER_DWELL_TIME
                }
            >
                <JPDOverlayTemplate size="sm" showBrandFooter={false}>
                    <LoadingAnimationContainer />
                </JPDOverlayTemplate>
            </UfoCustomTimingWrapper>
        </div>
    );
};
